import React from 'react';
import FormMentionEditor from '../../Component/FormMentionEditor';
import PropTypes from 'prop-types';

const ValidationField = ({ label, ...props }) => (
  <>
    <p className={`s-text m-b-0 ${label === 'Min value' ? 'm-t-0' : ''}`}>{label}</p>
    <FormMentionEditor
      style={{
        width: '100%',
        verticalAlign: 'top',
        minHeight: '16px',
      }}
      hideScrollBar={true}
      {...props}
    />
  </>
);

const NumberValidation = ({ validation, onChange, availablePlaceholders, assignTask }) => {
  const fields = [
    { label: 'Min value', field: 'min', placeholder: 'Enter minimum value' },
    { label: 'Max value', field: 'max', placeholder: 'Enter maximum value' },
    {
      label: 'If invalid then display this message',
      field: 'message',
      placeholder: 'Enter validation message',
    },
  ];

  const handleChange = field => val => {
    if (field === 'message') {
      onChange({ ...validation, [field]: val });
      return;
    }

    const isPlaceholder = val.includes('${') || val.includes('!{');
    if (isPlaceholder) {
      onChange({ ...validation, [field]: val });
      return;
    }

    const numericValue = val.replace(/[^\d.-]/g, '');
    onChange({ ...validation, [field]: numericValue });
  };

  return (
    <div>
      {fields.map(({ label, field, placeholder }) => (
        <ValidationField
          key={field}
          label={label}
          value={String(validation[field] || '')}
          text={String(validation[field] || '')}
          onChange={handleChange(field)}
          placeholder={placeholder}
          onFocus={e => {}}
          assignTask={assignTask}
          {...(availablePlaceholders != null && {
            availablePlaceholders: availablePlaceholders,
          })}
        />
      ))}
    </div>
  );
};

NumberValidation.propTypes = {
  validation: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  availablePlaceholders: PropTypes.array,
  assignTask: PropTypes.bool,
};

export default NumberValidation;
